<template>
  <div class="card">
    <div class="order-header">
      <div class="order-header__actions">
        <a @click="$router.go(-1)" class="btn btn-xs btn-secondary">Back to Order History</a>
      </div>

      <h5 class="order-header__title">Order: {{ orderinfo[0].ordernumber }}</h5>
      <p class="order-header__account">Account: {{ $store.getters.customer }}</p>
      <div class="order-header__subtitle">
        <mark>Order {{ orderinfo[0].ordernumber }}</mark> was placed on <mark>{{ orderinfo[0].ordermonth }}/{{ orderinfo[0].orderday }}/{{ orderinfo[0].orderyear }}</mark>.
        <!-- and has been <mark>shipped(x)</mark> -->
        <div class="account-nav__divider" role="presentation"></div>
        <!-- <p>
          Tracking number:
          <a href="http://www.ups.com/WebTracking/processInputRequest?loc=en_US&Requester=NES&tracknum=1Z3805280370188498&AgreeToTermsAndConditions=yes&WT.z_eCTAid=ct1_eml_Tracking__ct1_eml_qvn_eml_5shp&WT.z_edatesent=10162020"
            target="_blank" >
            9U3805280370168527(x)</a>
        </p> -->
      </div>
      <div class="order-header__actions">
        <td>
          <a
            href="pdf/DMS-Qwik Order-7592.pdf"
            target="_blank"
            class="btn btn-xs btn-primary"
            >Download PDF(x)</a
          >
        </td>
      </div>
    </div>
    <div class="card-divider"></div>
    <div class="card-table">
      <div class="table-responsive-sm">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Product</th>
              <th class="text-right">Quantity</th>
              <th class="text-right">Price</th>
              <th class="text-right">Core</th>
              <th class="text-right">Total</th>
            </tr>
          </thead>
          <tbody class="card-table__body card-table__body--merge-rows">
            <order-details-info-line
                v-for="item in itemlist"
                :key="item.item"
                :itemnumber="item.item"
                :itemdesc="item.desc"
                :quantity="item.quantity"
                :price="item.price"
                :core="item.core"
                :total="item.total"
                :mfgcode="item.DIMFGC"
            ></order-details-info-line>
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <th class="justify-right--elements-text">Total</th>
              <td class="justify-right--elements-text">${{ orderinfo[0].totalamount }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import OrderDetailsInfoLine from "./OrderDetailsInfoLine.vue";
export default {
  components: {
    OrderDetailsInfoLine
  },
  props: {
      itemlist: {
          type: Array,
          required: true
      },
      orderinfo: {
          type: Array,
          required: true
      },
  }
};
</script>